import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { MainService } from "../../main.service";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { MatSnackBar } from "@angular/material";
@Component({
  selector: "app-view-bookings",
  templateUrl: "./view-bookings.component.html",
  styleUrls: ["./view-bookings.component.scss"],
})
export class ViewBookingsComponent implements OnInit {
  questList: any = [];
  currentTime = "";
  user: any;
  total: number = 0;
  pagelimit: number = 10;
  totalPage: number;
  currentPage: number = 0;
  searchText;
  any;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  constructor(
    private mainservice: MainService,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    //  this.currentTime =  this.greeting()
    //  this.user = JSON.parse(localStorage.getItem('userData'));
    //  console.log('this.',this.questList)
    this.getBookingList("");
  }

  greeting() {
    const hour = moment().hour();

    if (hour > 16) {
      return "Good evening";
    }

    if (hour > 11) {
      return "Good afternoon";
    }

    return "Good morning";
  }

  bookingList = [];
  getBookingList(text) {
    this.isLoading = true;
    var queryValue = this.queryParams();
    this.mainservice.getBookingList(queryValue).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.bookingList = res.data.bookings;
          this.SetPage();
          console.log(this.bookingList, "res");
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  queryParams() {
    let query =
      "limit=" +
      this.pagelimit +
      "&offset=" +
      this.pagelimit * this.currentPage;
    if (this.searchText && this.searchText != "")
      query = query + "&text=" + this.searchText ;
    // if (this.searchName && this.searchName != "") query = query + "&text=" + this.searchName+"&";

    return query;
  }

  scholardetail: any;
  bookingDetail: any;
  kidsDetail: any;
  OpenModal(content, btn, data) {
    this.bookingDetail = data;
    this.kidsDetail = this.bookingDetail.kidsArray;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    this.questList = [];
  }
  convertSecondsToTime(seconds: number): string {
    const date = new Date(seconds * 1000);

    let hours = date.getUTCHours(); // Use getUTCHours to avoid timezone offsets
    const minutes = date.getUTCMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle the case where hours = 0, should be 12 AM

    // Pad minutes with leading zero if necessary
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutesStr} ${ampm}`;
  }
  // convertSecondsToDate(seconds) {
  //   const date = new Date(seconds * 1000);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = String(date.getFullYear()).slice(-2);
  //   return `${day}/${month}/${year}`;
  // }
  convertSecondsToDate(seconds: number): string {
    const date = new Date(seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }
  choosedFile: File;
  onPicsfileChanged(event, index) {
    this.isLoading = true;
    this.choosedFile = event.target.files[0];
    if (event.target.files.length == 0) {
      this.isLoading = false;
      false;
    }

    this.mainservice.uploadImage(this.choosedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.questList[index]["valuesText"] = res.data.url;
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  SetPage() {
    this.totalPage = 0;
    this.totalPage = this.total / this.pagelimit;
    this.totalPage = Math.ceil(this.totalPage);
    if (this.totalPage == 1 || this.total <= this.pagelimit) {
      this.totalPage = 1;
    }
  }
  searchFiltersBtn() {
    this.getBookingList("");
  }
  nextPage() {
    this.currentPage = this.currentPage + 1;
    this.getBookingList("");
  }
  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.getBookingList("");
  }
  changePageLimit() {
    this.currentPage = 0;
    this.getBookingList("");
  }
  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
